<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <!-- table start -->
        <div class="card mb-4">
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <nav>
                <!-- <Search :PlaceHolder="placeHolderText" @search="handleSearch" /> -->
                <Search
                  :placeholder="'Srch.. name, phone, email, OPD/IPD'"
                  @onsearch="handleSearch"
                />
              </nav>
              <table class="table table-hover align-items-center mb-0">
                <thead class="thead-light">
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder"
                    >
                      #
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder"
                    >
                      Patient Name
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder"
                    >
                      OPD/IPD
                    </th>
                    <th></th>
                  </tr>
                </thead>

                <div v-if="tableLoading">
                  <div class="text-center py-4">
                    <div
                      class="spinner-border text-primary"
                      role="status"
                    ></div>
                    <p class="mt-2">Loading...</p>
                  </div>
                </div>

                <tbody v-if="users.length">
                  <tr
                    v-for="user in users"
                    :key="user.patient_id"
                    class="table-row-hover"
                  >
                    <td>#{{ user.id }}</td>
                    <td>
                      <div class="d-flex flex-column">
                        <h6 class="mb-0 text-sm">{{ user.name }}</h6>
                        <small class="text-secondary">{{
                          user.email || "--"
                        }}</small>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs mb-1">OPD/{{ user.opd || "--" }}</p>
                      <p class="text-xs text-secondary">
                        IPD/{{ user.ipd || "--" }}
                      </p>
                    </td>
                    <td>
                      <button
                        @click="showPatientData(user.patient_id)"
                        class="btn btn-sm btn-primary rounded-pill px-3"
                      >
                        More
                      </button>
                      <button
                        @click="EditPatientData(user.patient_id)"
                        class="btn btn-sm btn-secondary rounded-pill px-3"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                </tbody>

                <div v-else>
                  <p class="text-center py-4 text-muted" v-if="!apiLoading">
                    No records found.
                  </p>
                </div>
              </table>

              <!-- Pagination   @page-change="handlePageChange" :current-page="currentPage" :total-pages="totalPags" -->
              <!-- <pagination :all-data="allData" @content-change="handleContentChange" /> -->
              <div v-if="apiLoading">Loading...</div>
              <pagination
                v-if="!apiLoading"
                :all-data="allData"
                @content-change="handleContentChange"
                @loader-set="loaderSet"
              />

              <!--  -->
              <PatientDetails
                v-if="showingPatientDataModal"
                :patient_id="current_patient_id"
                @close="closParientDetailsModal"
              />

              <EditPatientDetails
                v-if="showingEditPatientDataModal"
                :patient_id="current_patient_id"
                @close="closeEditParientDetailsModal"
              />
            </div>
          </div>
        </div>
        <!-- table end -->
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import Pagination from "../components/pagination.vue";
import Search from "../components/search.vue";
import PatientDetails from "./components/patient_details.vue";
import EditPatientDetails from "./components/edit_patient_details.vue";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      showingPatientDataModal: false,
      showingEditPatientDataModal: false,
      current_patient_id: "",
      allData: {},
      apiLoading: true,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
    };
  },
  components: {
    Pagination,
    Search,
    PatientDetails,
    EditPatientDetails,
  },

  methods: {
    async handleSearch(searchTerm) {
      //console.log("the serch rem is " +searchTerm);
      try {
        this.apiLoading = true;
        const url = "searchCompanyUsers";
        const body = { search_param: searchTerm };

        const rs = await generalApiRequest(url, "GET", body, 1);

        this.allData = rs.data;
        this.apiLoading = false;
        console.log(this.allData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    showPatientData(pat_id) {
      this.current_patient_id = pat_id;
      this.showingPatientDataModal = true;
    },
    EditPatientData(pat_id) {
      this.current_patient_id = pat_id;
      this.showingEditPatientDataModal = true;
    },
    closeEditParientDetailsModal() {
      this.current_patient_id = "";
      this.showingEditPatientDataModal = false;
    },
    closParientDetailsModal() {
      this.current_patient_id = "";
      this.showingPatientDataModal = false;
    },

    handleContentChange(contents) {
      // console.log("procceds");
      // console.log(contents);
      this.users = contents;
    },

    loaderSet(value) {
      if (value == true) {
        this.users = [];
      }
      this.tableLoading = value;
      //console.log(value);
      //this.apiLoading = value;
    },

    async callApi() {
      try {
        const url = "getCompanyUsers?page=1";
        const body = {};

        // const data = await getMethodRequest(url, body, 1);
        const data = await generalApiRequest(url, "GET", body, 1);
        // console.log(data);
        this.allData = data.data;
        this.apiLoading = false;
        this.tableLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },

  mounted() {
    this.callApi();
  },
};
</script>
<style scoped>
.table-row-hover:hover {
  background-color: #f9f9f9;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.spinner-border {
  width: 2rem;
  height: 2rem;
}

.btn-primary {
  background-color: #1976d2;
  border-color: #1976d2;
}

.btn-primary:hover {
  background-color: #1565c0;
  border-color: #1565c0;
}
</style>
